// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__4aGCK","upload":"Small_upload__31LPS","imageWrap":"Small_imageWrap__2SWy0","removeBtn":"Small_removeBtn__12UwY"};